module.exports = __webpack_public_path__ + "img/aa1.dd7ddefc.jpg";